import * as React from 'react';

const LocationPin16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M8 0a6.5 6.5 0 0 0-6.5 6.5c0 5.057 3.946 8.001 5.69 9.055a1.56 1.56 0 0 0 1.62 0C10.554 14.5 14.5 11.557 14.5 6.5A6.5 6.5 0 0 0 8 0m0 1.5c2.757 0 5 2.243 5 5 0 4.147-3.154 6.646-4.744 7.642a.47.47 0 0 1-.505 0C6.168 13.14 3 10.621 3 6.5c0-2.757 2.243-5 5-5m0 2.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5m0 1.5c.689 0 1.25.562 1.25 1.25 0 .689-.561 1.25-1.25 1.25S6.75 7.189 6.75 6.5c0-.688.561-1.25 1.25-1.25"
  }
));
LocationPin16.Size = 16;
LocationPin16.Title = "LocationPin";

export { LocationPin16 as default };
